export const GET_PRODUCTS = "APP/PRODUCTSPAGE/GET_PRODUCTS";
export const GET_PRODUCTS_SUCCESS = "APP/PRODUCTSPAGE/GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "APP/PRODUCTSPAGE/GET_PRODUCTS_FAILURE";

export const GET_STRUCTURED_CONTENT = "APP/PRODUCTSPAGE/GET_STRUCTURED_CONTENT";
export const GET_STRUCTURED_CONTENT_SUCCESS = "APP/PRODUCTSPAGE/GET_STRUCTURED_CONTENT_SUCCESS";
export const GET_STRUCTURED_CONTENT_FAILURE = "APP/PRODUCTSPAGE/GET_STRUCTURED_CONTENT_FAILURE";

export const GET_USER_CART_ID = "APP/PRODUCTPAGE/GET_USER_CART_ID";
export const GET_USER_CART_ID_SUCCESS = "APP/PRODUCTSPAGE/GET_USER_CART_ID_SUCCESS";
export const GET_USER_CART_ID_FAILURE = "APP/PRODUCTSPAGE/GET_USER_CART_ID_FAILURE";

export const RESET_USER_CART_ID = "APP/PRODUCTPAGE/RESET_USER_CART_ID";


export const GET_NEW_ARRIVALS_PRODUCT = "APP/PRODUCTPAGE/GET_NEW_ARRIVALS_PRODUCT";
export const GET_NEW_ARRIVALS_PRODUCT_SUCCESS = "APP/PRODUCTSPAGE/GET_NEW_ARRIVALS_PRODUCT_SUCCESS";
export const GET_NEW_ARRIVALS_PRODUCT_FAILURE = "APP/PRODUCTSPAGE/GET_NEW_ARRIVALS_PRODUCT_FAILURE";

export const GET_TOP_CATEGORIES_PRODUCT = "APP/PRODUCTPAGE/GET_TOP_CATEGORIES_PRODUCT ";
export const GET_TOP_CATEGORIES_PRODUCT_SUCCESS = "APP/GET_TOP_CATEGORIES_PRODUCT_SUCCESS";
export const GET_TOP_CATEGORIES_PRODUCT_FAILURE = "APP/PRODUCTSPAGE/GET_TOP_CATEGORIES_PRODUCT_FAILURE";

export const GET_BLOG_LIST = "APP/PRODUCTPAGE/GET_BLOG_LIST ";
export const GET_BLOG_LIST_SUCCESS = "APP/GET_BLOG_LIST_SUCCESS";
export const GET_BLOG_LIST_FAILURE = "APP/PRODUCTSPAGE/GET_BLOG_LIST_FAILURE";

export const PRODUCT_COUNT_IN_CART = "APP/PRODUCTPAGE/PRODUCT_COUNT_IN_CART";

